import { Component } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { EmailValidator, EqualPasswordsValidator } from '../theme/validators';

import { UserForgotPasswordService } from 'app/pages/forgotPassword/forgotPassword.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ViewChild,ElementRef } from '@angular/core'; 

declare var swal: any;  //For Sweet Alert
declare var google: any;  //For Sweet Alert

@Component({
    selector: ' resetPassword ',
    templateUrl: './resetPassword.html',
    styleUrls: ['./resetPassword.scss'],
    providers: [UserForgotPasswordService]
})
export class ResetPassword {

    @ViewChild('inputPassword3') inputPassword3: ElementRef;

    public form: FormGroup;
    public password:any;
    public passwordHash:any;
    public confirmPassword:any;

    constructor(fb: FormBuilder, private postsService: UserForgotPasswordService, private router: Router, private activatedRoute: ActivatedRoute) {
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.passwordHash = params.resetKey;
        });

        this.form = fb.group({
          'password': ['', Validators.compose([Validators.required])],
          'confirmPassword': ['', Validators.compose([Validators.required])]
        });
    }

    onSubmit(values) {
        if (this.password == this.confirmPassword) {
            this.postsService.resetPassword(values, this.passwordHash).subscribe(posts => {
                if (posts.status == 1) {
                    swal({ title: "Success!", text:posts.msg, type: 'success'});
                    this.router.navigate(['login']);
                } else {
                    swal({ title: "Failed!", text:posts.msg, type: 'warning'});
                }
            });
        }  else {
            swal({ title: "Both passwords are not matching!", type: 'warning'});

            this.password = '';
            this.confirmPassword = '';
        }
    }

    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/resetPassword/resetPassword.component.ts